<template>

  <div class="head container" id="top">

    <div class="logo fl col-md-9 col-lg-9 d-none d-md-block">
      <a href="/" style="display: flex;height:100%;align-items: center;">
        <img :src="base_url+logo_url" ></a>
    </div>

    <div class="dh fr  col-md-3 d-none d-md-block">
      <p>全国服务电话 :</p>
      <a :href="'tel:'+tel" class="red">{{ tel }}</a>
    </div>


    <nav id="navcont" class="navbar navbar-expand-md navbar-light bg-light d-block d-md-none">
      <div class="container-fluid">
        <a class="navbar-brand" href="/">
          <img :src="base_url+logo_url" >
        </a>
        <button class="navbar-toggler col-lg-3" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ">
            <li v-for="item in navs" :key="item.id" :class="'nav-item '+(item.children?'dropdown':'')">
              <a  v-if="item.children" class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
               {{item.name}}
              </a>
              <a v-else :href="'/nav/list/'+item.id" class="nav-link">{{ item.name }}</a>

              <ul v-if="item.children" class="dropdown-menu " aria-labelledby="navbarDropdown">
                <li v-for="citem in item.children" :key="citem.id">
                  <a :href="'/nav/list/'+citem.id" class="dropdown-item">{{ citem.name }}</a>
                </li>

              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>


  </div>
  <div class="clear"></div>
</template>
<script>
import {getNavs} from "@/api/home"
import {handleNavData} from "@/utils"
export default {
  props: {
    initData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  watch: {
    initData: {
      handler(v) {
        this.logo_url = v.header_logo.url
        this.tel = v.tel
      },
      deep: true
    }
  },
  data() {
    return {
      base_url:process.env.VUE_APP_BASE_API,
      logo_url: this.initData.header_logo.url,
      tel: this.initData.tel,
      navs: {}//响应式用
    }
  },
  created() {
    this.getList()
  },
  methods:{
    getList() {
      const temp ={_sort:'sort:ASC'}
      getNavs(temp).then((response) => {
        this.navs = handleNavData(response)
      })
    },
  }
}
</script>
